import { jsx as h } from "react/jsx-runtime";
import c from "../../../hooks/useBreakpoint.js";
import "react";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import { getToneContentColorRole as u } from "../../../styles/colors/content/getToneContentColorRole.js";
import { headingLineHeightMap as y, typographyHeadingLevelMobileAndTabletMap as M, typographyHeadingLevelMap as b } from "../../../styles/typography/typography.js";
import "../../layout/Stack/Stack.js";
import x from "../../layout/Box/Box.js";
import "styled-components";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../layout/Columns/ColumnsContext.js";
import { uppercaseStyles as H, truncateStyles as T } from "../consts.js";
import { useThemeInMode as A } from "../../../context/theme/hooks.js";
function E({
  children: e,
  level: o,
  tone: t = "neutral",
  emphasis: r = "high",
  onHighEmphasisSurface: i = !1,
  lineHeight: n = "large",
  weight: m = "bold",
  dataNoTranslate: p,
  align: a,
  uppercase: l = !1,
  truncate: s = !1
}) {
  const g = A()[u({
    tone: t,
    emphasis: r,
    onHighEmphasisSurface: i
  })], { isMobileOrTablet: f } = c(), d = f && o === "1" ? M[o] : b[o];
  return /* @__PURE__ */ h(
    x,
    {
      ...d,
      ...y[n],
      fontWeight: m,
      textAlign: a,
      margin: "none",
      padding: "none",
      dataNoTranslate: p,
      color: g,
      ...l && H,
      ...s && T,
      children: e
    }
  );
}
export {
  E as default
};
